<template>
    <div ref="fristhome">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>单险种多车</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card" style="margin-top:20px">
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    autocomplete="on"
                    size="mini">
                <dl style="display:flex;flex-direction: row;align-items: center;justify-content:flex-start;">
                    <dt style="background-color: #e1f3d8;border-radius: 5px;width: 30%;">
                        <h5 style="color: #666;padding:20px 0 0 20px;">其他渠道保险～建档</h5>
                        <p style="display:flex;flex-direction: row;align-items: center;padding: 10px;" >
                            <el-form-item>
                                <el-button   @click.native="addData">单车多险种</el-button>
                            </el-form-item>
<!--                            <el-form-item>-->
<!--                                <el-button  type="primary" @click.native="addByProduct">单险种多车</el-button>-->
<!--                            </el-form-item>-->
                        </p>
                    </dt>
                    <dd style="background-color: #e6f1fe;border-radius: 5px;margin-left: 50px;width: 30%;">
                        <h5  style="color: #666;padding:20px 0 0 20px;">系统内保险</h5>
                        <p style="display:flex;flex-direction: row;align-items: center;padding: 10px;">
<!--                            <el-form-item>-->
<!--                                <el-button    @click.native="addSysCar">系统单车多险种</el-button>-->
<!--                            </el-form-item>-->
                            <el-form-item>
                                <el-button  @click.native="addSysProduct">系统单险种多车</el-button>
                            </el-form-item>
                        </p>
                    </dd>
                </dl>
            </el-form>
            <header style="color: #3a8ee6;font-weight: bold;padding: 10px 0"><span>提示：</span><span>单险种多车～建档</span></header>
            <el-form label-width="120px" :inline="true" size="mini"
                     :model="addForm"
                     ref="addForm"
                     :rules="rules">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="基本信息" name="first">

                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="产品名称" >
                                    <el-select
                                            v-model="addForm.product_id"
                                            size="mini"
                                            style="width: 180px;"
                                            placeholder="请选择产品">
                                        <el-option
                                                v-for="item in productList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="保险公司" prop="corp_id">
                                   <!-- <el-input style="width: 180px;" v-model="addForm.corp_name"/>-->
                                  <!--<el-select
                                      v-model="addForm.corp_id"
                                      filterable
                                      allow-create
                                      default-first-option
                                      size="mini"
                                      style="width: 150px;"
                                      remote
                                      reserve-keyword
                                      placeholder="请输入关键词"
                                      :remote-method="corpRemoteMethod"
                                      :loading="corpLoading">
                                    <el-option
                                        v-for="item in corpList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                  </el-select>-->
                                <el-select  v-model="addForm.corp_id" filterable allow-create  default-first-option
                                            size="mini" style="width: 150px;"  placeholder="请输入关键词" @change="getline"> 
                                    <el-option v-for="item in corpList" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="保费" prop="price">
                                    <el-input style="width: 180px;" v-model="addForm.real_price"/>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="净费" >
                                    <el-input style="width: 180px;" v-model="addForm.sell_price"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="渠道联系人" prop="contact_name">
                                  <el-select v-model="addForm.link_name" size="mini" style="width: 180px;" placeholder="请选择联系人" @change="setcontact">
                                    <el-option v-for="item in contact" :key="item.id" :label="item.contact_name" :value="item.contact_name"> </el-option>
                                  </el-select>
                                    <!--<el-input style="width: 180px;" v-model="addForm.line_name"/>-->
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="渠道联系电话" prop="remark">
                                    <el-input style="width: 180px;" v-model="addForm.link_tel" readOnly/>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="24">
                            <el-col :span="24">
                                <div class="table_box">
                                    <div style="text-align: left;padding:10px 0;">
                                        <el-button type="primary" size="mini" @click="addItem">新增车辆</el-button>
                                    </div>
                                    <el-table :data="list" border  size="mini" :summary-method="getSummaries" show-summary style="width: 100%;" stripe height="260">
                                        <el-table-column prop="product_id" min-width="10%" label="车辆名称" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.plate_number}}</span>
                                                <el-input  size="mini" prefix-icon="el-icon-search" @click.native.prevent="chooseCar(scope.$index)" v-if="scope.row.isEgdit" v-model="scope.row.plate_number"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="10%" prop="vehicle_type" label="车辆类型" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.isEgdit">{{scope.row.vehicle_type}}</span>
                                                <el-input size="mini" v-if="!scope.row.isEgdit" v-model="scope.row.vehicle_type"></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column min-width="10%"  prop="order_date" label="投保日期" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.effective_date}}</span>

                                                <el-date-picker
                                                        size="mini"
                                                        style="width: 150px;"
                                                        value-format="yyyy-MM-dd"
                                                        v-if="scope.row.isEgdit"
                                                        v-model="scope.row.effective_date"
                                                        type="date"
                                                        placeholder="选择投保日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="10%"  prop="start_time"  label="保险起期" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.start_time}}</span>
                                                <el-date-picker
                                                        size="mini"
                                                        @change="startDateChange($event,scope.$index)"
                                                        style="width: 150px;"
                                                        value-format="yyyy-MM-dd"
                                                        v-if="scope.row.isEgdit"
                                                        v-model="scope.row.start_time"
                                                        type="date"
                                                        placeholder="选择投保日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="10%" prop="end_time"  label="保险止期" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.end_time}}</span>
                                                <el-date-picker
                                                        size="mini"
                                                        style="width: 150px;"
                                                        value-format="yyyy-MM-dd"
                                                        v-if="scope.row.isEgdit"
                                                        v-model="scope.row.end_time"
                                                        type="date"
                                                        placeholder="选择投保日期">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>

                                        <el-table-column prop="remark" label="备注" align='center' min-width="10%">
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">{{scope.row.remark}}</span>
                                                <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.remark"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column  min-width="12%" label="保单上传" align='center'>
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.isEgdit">查看保单</span>
                                                <el-upload
                                                        drag
                                                        class="avatar-uploader"
                                                        action="#"
                                                        :auto-upload="false"
                                                        :show-file-list="false"
                                                        :on-change="(file, fileList) => {handleChange(file, fileList, scope.$index)}"
                                                        :multiple=false
                                                        :file-list="scope.row.fileList"
                                                        :limit="1"
                                                        :on-success="handleAvatarSuccess"
                                                        :before-upload="beforeAvatarUpload">
                                                    <img v-if="scope.row.file_url" :src="scope.row.file_url" class="avatar">
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                            </template>
                                        </el-table-column>
                                        <el-table-column min-width="15%" label="操作" align='center'>
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="deleteItem(scope.$index, list)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="保单文件" name="second">

                        <el-row :gutter="24">
                            <el-col :span="24">
                                <div class="upload_group">
                                    <div class="upload_list">

                                    </div>
                                </div>
                            </el-col>
                        </el-row>

                    </el-tab-pane>
                </el-tabs>

                <el-row :gutter="24">
                    <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
                        <el-form-item>
                            <el-button @click="close">取消</el-button>
                            <el-button type="primary" @click="save('addForm')">保存</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo"/>
        <!---->
        <el-dialog width="60%" title="产品列表" :visible.sync="productVisible" @close="closeProduct">
            <el-form size="mini" :model="searchForm" ref="searchForm" :inline="true">
                <el-form-item label="产品名称" prop="keywords">
                    <el-input   v-model="searchForm.keywords" palceholder="请输入产品名称"></el-input>
                </el-form-item>
                <el-form-item prop="name">
                    <el-button type="primary">查询</el-button>
                </el-form-item>
                <div>
                    <el-table :data="productList" border  size="mini" style="width: 100%;" stripe height="260">
                        <el-table-column label="选择" align="center" width="55">
                            <template slot-scope="scope">
                                <el-radio :label="scope.$index" v-model="pIndex"  @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="产品名称"></el-table-column>
                    </el-table>
                </div>
                <el-row>
                    <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                        <el-button size="mini" @click="productVisible = false">取消</el-button>
                        <el-button  size="mini" type="primary" @click="okProduct">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!---->

        <!--车辆列表-->
        <el-dialog width="60%" title="车辆列表" :visible.sync="carVisible" @close="closeProduct">
            <el-form size="mini" :model="searchForm1" ref="searchForm1" :inline="true">
                <el-form-item label="车辆名称" prop="keywords">
                    <el-input   v-model="searchForm1.keywords" palceholder="请输入车辆名称"></el-input>
                </el-form-item>
                <el-form-item prop="name">
                    <el-button type="primary" @click="searchCar">查询</el-button>
                </el-form-item>
                <div>
                    <el-table :data="carList" border  size="mini" style="width: 100%;" stripe height="260">
                        <el-table-column label="选择" align="center" width="55">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.$index" v-model="scope.row.checked" @change.native="getCurrentCarRow(scope.row,scope.$index)">&nbsp;</el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                                width="120"
                                prop="plate_number"
                                :show-overflow-tooltip='true'
                                label="车辆号码">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                prop="vehicle_type"
                                :show-overflow-tooltip='true'
                                label="车辆类型">
                        </el-table-column>
                        <el-table-column
                                prop="vin"
                                width="150"
                                :show-overflow-tooltip='true'
                                label="车辆识别代码">
                        </el-table-column>
                        <el-table-column
                                prop="model"
                                width="180"
                                :show-overflow-tooltip='true'
                                label="品牌型号">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                :show-overflow-tooltip='true'
                                prop="use_character"
                                label="使用性质">
                        </el-table-column>
                        <el-table-column
                                width="120"
                                :show-overflow-tooltip='true'
                                prop="out_to_out"
                                label="外廓尺寸">
                        </el-table-column>
                    </el-table>
                </div>
                <el-row>
                    <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                        <el-button size="mini" @click="carVisible = false">取消</el-button>
                        <el-button  size="mini" type="primary" @click="okProduct">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!---->

    </div>
</template>
<script>
    import moment from 'moment'     //日期时间转换
    import eCar from "../common/eCar";
    import Watermark from "../../utils/waterMark";
    export default {
        name:'eInsurance',
        props:['carVisibleProp'],
        components: {
            eCar
        },
        data(){
            return {
                applicantLoading:false,
                applicantList:[],
                applicantStates:[],
                corp:'',
                corpLoading:'',
                corpList:[],
                corpStates:[],

                isShowCar:false,

                carVisible:false,
                carList:[],
                productList:[],
                productVisible:false,
                index:0,
                pIndex:-1,
                productId:[],
                options: [],
                carList1: [],
                loading: false,
                states: [],

                searchForm:{
                    keywords:'',
                },
                searchForm1:{
                    keywords:'',
                },
                searchRules:{

                },
                addForm:{
                    price:'',
                    real_price:'',
                    sell_price:'',
                    product_name:'',
                    product_id:'',
                    corp_id:'',
                    corp_name:'',
                    link_id:'',
                    link_name:'',
                    link_tel:'',
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                },
                rules: {
                    applicant: [{ required: true, message: '请输入投保人', trigger: 'blur' }],
                    insured: [{ required: true, message: '请输入被投保人', trigger: 'blur' }],
                },
                title:'保单新增',
                car_number:'',
                fileList:[],
                activeName: 'first',
                insurance_date:'',
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                list: [],
                contact:{}
            }
        },
        mounted() {
            this.carList1 = this.states.map(item => {
                return { value: `${item}`, label: `${item}` };
            });
            this.corpDataList();
            this.getProductList();
            this.getCarList();
            this.contactList();
          let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss")
          this.$nextTick(() => { //要加载完才能获取$refs
            Watermark.set(str,this.$refs.fristhome)
          })
        },
        methods:{
          setcontact(value){
            //console.log(value)
            this.contact.forEach(item=>{
              if (item.contact_name === value) {
                ////console.log(item.plate_number) // 打印输出了label、value值 plate_number
                this.$set(this.addForm,'link_tel' , item.contact_mobile) //不用set 的形式，页面数据不更新
                this.addForm.link_name = value
                this.addForm.link_id = item.id
                //this.addForm.line_mobile = item.contact_mobile
              }
            })
          },
          //联系人
          contactList(){
            const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              page: 1,
              pageSize:50
            }
            this.$axios.getOtherChannelList(param).then(res=>{
              if(res.code == 200){
                this.contact = res.data.data
              }else{
                this.$message.error(res.msg);
              }
            }).catch(error=>{
              //console.log(error);
            })
          },
            searchCar(){
                this.getCarList();
            },
            beforeAvatarUpload(){

            },
            handleAvatarSuccess(){

            },
            // 新增
            addData() {
                this.$router.push('/insuranceAdd');
            },
            addByProduct(){
                this.$router.push('/insuranceAddByProduct');
            },
            addSysProduct(){
                this.$router.push('/insuranceSysProduct');
            },
            addSysCar(){
                this.$router.push('/insuranceSysCar');
            },
            getCurrentRow(row){
                this.addForm.product_name=row.name;
                this.addForm.product_id=row.id;
            },
            getCurrentCarRow(row,index){
              if(row.checked)
              {
                if(this.list.length>0){
                    for (var i=0;i<this.list.length;i++){
                        if(this.list[i].plate_number==row.plate_number){
                            this.$message.error("车辆不能重复添加");
                            return;
                        }
                    }
                }
                this.carList[index].checked = true
                let item = {
                    owner_id:row.shop_id,//被投保人Id
                    owner_name:row.allPerson,//被投保认名称
                    owner_idcard:row.shop?row.shop.credit_code:'',//被投保人身份证号
                    owner_mobile:'',//被投保人手机号
                    shop_id:row.shop_id,//投保人ID
                    toubao_name:row.allPerson,//投保人姓名
                    toubao_idcard:row.shop?row.shop.credit_code:'',//投保人身份证号
                    plate_number:row.plate_number,
                    allPerson:row.allPerson,
                    vehicle_type:row.vehicle_type,
                    vin:row.vin,
                    out_to_out:row.out_to_out,
                    model:row.model,
                    car_id:row.id, //车辆ID
                    effective_date:'',//签单日期
                    start_time:'', //保险起期
                    end_time:'', //保险结束日期
                    remark: row.remark,//险种订单备注
                    firstNum: null,
                    isEgdit: true,
                    file_url:'',
                    fileList:[]
                }
                this.list.push(item)
            /*
                this.list[index].plate_number=row.plate_number;
                this.list[index].vehicle_type=row.vehicle_type;
                this.list[index].out_to_out=row.out_to_out;
                this.list[index].model=row.model;
                this.list[index].vin=row.vin;
                this.list[index].car_id=row.id;
                this.list[index].allPerson=row.allPerson;
                this.list[index].remark=row.remark;
                this.list[index].owner_id= row.shop_id;
                this.list[index].owner_name= row.allPerson;
                this.list[index].owner_idcard= row.shop?row.shop.credit_code:'';
                this.list[index].shop_id= row.shop_id;
                this.list[index].toubao_name= row.allPerson;
                this.list[index].toubao_idcard= row.shop?row.shop.credit_code:'';
            */
              }else{
                this.carList[index].checked = false
                this.list.forEach((lItem, Lindex)=>{
                  if(lItem.plate_number == this.carList[index].plate_number)
                  {
                    this.$delete(this.list, Lindex);
                  }
                })
              }
              //console.log('carList',this.carList)
            },
            getCarList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    // pageNum:this.pageNum,
                    // pageSize:this.pageSize
                }
                if(this.searchForm1.keywords){
                    param.queryParams=this.searchForm1.keywords;
                }
                this.$axios.carFilesList(param).then(res=>{
                    if(res.code == 200){
                        this.carList = res.data.data
                        for(let key in this.carList){
                          this.$set(this.carList[key],'checked',false)
                        }
                        //this.total = res.data.total
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },
            //保司选择变动时 触发
            getline(rows){
                let ids=[];
                this.corpList.forEach(function(e){
                    ids.push(e.id);
                });
                //console.log('id列表：',ids)
   
                if(!ids.includes(rows)){
                    //this.list[index].corp_id = '';
                    //this.list[index].corp_name = rows
                    //this.addForm.corp_id = ''
                    this.addForm.corp_name = rows
                }
                
               //console.log('触发：',rows)
            },
            corpDataList(){
                let param={
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                        page:1,
                        limit:1000
                    }
                    this.$axios.corpList(param).then(res=>{
                        if(res.code == 200){
                            this.corpList = res.data.data;
                        }
                    }).catch(error=>{
                        //console.log(error);
                    })
            },
          corpRemoteMethod(query){
            if (query !== '') {
              this.corpLoading = true;
              let param={
                queryParams:query,
                //operator_id:sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.corpList(param).then(res=>{
                if(res.code == 200){
                  this.corpStates = res.data.data;
                  this.corpLoading = false;
                  this.corpList = this.corpSet.filter(item => {
                    return item.name;
                  });
                  if(this.corpList.length<=0)
                  {
                    this.addForm.corp_name = query
                  }

                }else{
                  this.$message.error(res.msg);
                }
              }).catch(error=>{
                //console.log(error);
              })
            } else {
              this.corpList = [];
            }
          },
            getProductList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.insuranceProdcutList(param).then(res=>{
                    if(res.code == 200){
                        this.productList = res.data.data
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },
            applicantRemoteMethod(query){
                if (query !== '') {
                    this.applicantLoading = true;
                    let param={
                        queryParams:query,
                        operator_id:sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                    }

                    this.$axios.shopList(param).then(res=>{
                        if(res.code == 200){
                            this.applicantStates = res.data.data;
                        }else{
                          this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        //console.log(error);
                    })
                    setTimeout(() => {
                        this.applicantLoading = false;
                        this.applicantList = this.applicantSet.filter(item => { // 这里的this.list，换为this.applicantSet
                            return item.name;
                        });
                    }, 1000);
                } else {
                    this.applicantList = [];
                }
            },
            chooseCarInfo(plate_number,...params){

                this.list[this.index].plate_number=plate_number;
                this.list[this.index].car_id=params[0];
                this.list[this.index].vehicle_type=params[1];
                this.list[this.index].allPerson=params[2];
                this.list[this.index].vin=params[3];

                this.list[this.index].shop_name=params[2];
                this.list[this.index].toubao_name=params[2];
            },
            handleClick(){

            },
            closeProduct(){

            },
            okProduct(){
             this.carVisible=false;

            },
            choosePro(index){
                this.carVisible=true;
                ////console.log('list0-------',this.list)
            },
            chooseCar(index){
                this.index=index;
                this.isShowCar=true;
            },

            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.carList1.filter(item => {
                            return item.name.indexOf(query) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            onClose(){
                this.$emit('close')
            },
            close(){
                this.$emit('close')
            },
            handleBeforeUpload(){

            },
            uploadSuccess(){

            },
            handleChange(file,fileList,index){
                let _this=this;

                //------上传到阿里云
                let carFd = new FormData()
                carFd.append('file', file.raw)
                carFd.append('file_type', 1)
                // carFd.append('file_value', this.addForm.vin)
                carFd.append('company_id', sessionStorage.getItem('company_id'))
                carFd.append('access_token', sessionStorage.getItem('token'))
                this.$axios.ossUploadFile(carFd).then(res11 => {

                    //console.log('aliyun--------',res11)
                    if (res11.code == 200) {
                        this.$message.success(res11.msg)
                        _this.list[index].file_url = res11.data.src;
                        //console.log('file_url--------', _this.list[index].file_url)

                    } else if (res11.code == 1) {
                        this.$message.error(res11.msg)
                    }
                }).catch(function (error) {
                    //console.log(error);
                })
                //------上传到阿里云
            },
            save(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        if(this.list.length<1){
                            this.$message.error("车辆必选")
                            return;
                        }
                        for(var i=0;i<this.list.length;i++){
                            var pid=this.list[i].car_id;
                            if(pid==null || pid==undefined || pid==''){
                                this.$message.error("车辆不能为空")
                                return;
                            }
                            var efDate=this.list[i].effective_date;
                            if(efDate==null || efDate==undefined || efDate ==''){
                                this.$message.error("请选择投保日期")
                                return;
                            }
                            var sDate=this.list[i].start_time;
                            if(sDate==null || sDate==undefined || sDate ==''){
                                this.$message.error("请选择保险起期")
                                return;
                            }
                            var eDate=this.list[i].end_time;
                            if(eDate==null || eDate==undefined || eDate ==''){
                                this.$message.error("请选择保险止期")
                                return;
                            }
                            // 创建两个日期对象
                            var date1 = moment(efDate, 'YYYY-MM-DD');
                            var date2 = moment(sDate, 'YYYY-MM-DD');
                            var date3 = moment(eDate, 'YYYY-MM-DD');

                            if (date2.isBefore(date1)) {
                                this.$message.error("保险起期要大于投保日期")
                                return;
                            }
                            if (date3.isBefore(date2)) {
                                this.$message.error("保险止期要大于保险起期")
                                return;
                            }
                        }
                        //console.log('save-addForm',this.addForm)
                        let param = this.addForm;

                        if(param.corp_name) {
                          param.corp_id = ''
                        }
                        //param.carList=this.list;
                        var carList=this.list;

                        param.carList=carList;

                        //console.log('addForm------',this.addForm);
                        //console.log('list-------',this.list)
                        this.$axios.saveGroupByProduct(param).then(res =>{
                            if(res.code == 200){
                                this.$message.success(res.msg)
                                this.$router.push('/insuranceTeamOrder')
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });

            },
            dealSpace(str){
                return str.replace(/&nbsp;/gi, " ");
            },
            //合计 表格每一列需要带上prop
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总数量';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '(个)';
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },
            //新增数据
            addItem() {
                this.carVisible=true;

            },
            //删除数据
            deleteItem(index, list) {
                list.splice(index, 1);
            },
            //编辑数据
            edit(index, row) {
                this.$set(row, 'isEgdit', true)
            },
            //编辑成功
            editSuccess(index, row) {
                this.$set(row, 'isEgdit', false)
            },
            startDateChange(date,idx){
                //console.log('start_time----',date)
                //console.log('idx----',idx)
                this.list[idx].start_time=date;

                var tmp= moment(date).add(1, 'y').format('YYYY-MM-DD');
                this.list[idx].end_time=  moment(tmp).subtract(1, 'days').format('YYYY-MM-DD');
                //console.log('end_time', this.list[idx].end_time)
            },
            getNextYearDay(date){


            },
            //处理默认选中当前日期
            getNowTime(y=0,m=0,d=0) {
                var now = new Date();

                var year = now.getFullYear()+y; //得到年份
                var month = now.getMonth(); //得到月份
                var date = now.getDate()+d; //得到日期
                var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
                month = month + 1+m;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                var defaultDate = `${year}-${month}-${date}${hour}`;
                //console.log(defaultDate)
                return defaultDate;
                //this.$set(this.addForm, "effective_date", defaultDate);
            },
        },
        computed: {
            applicantSet() {
                return this.applicantStates.map(item => {
                    return { id: `${item.id}`, name: `${item.name}-${item.name}` };
                });
            },
            corpSet() {
                return this.corpStates.map(item => {
                    return { id: `${item.id}`, name: `${item.name}` };
                });
            }
        },
    }
</script>
<style lang="less" scoped>
    //https://www.yzktw.com.cn/post/1262748.html
    /deep/.el-upload-dragger {
        width: 50px !important;
        height: 50px !important;
    }


    .upload_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .upload_list {
            width: 100px;
            margin-right: 1rem;

        }

        /deep/.el-upload-dragger .el-upload__text {
            font-size: 10px;
            color: #409EFF;
        }

        /deep/.el-icon-upload:before {
            width: 30px !important;
            height: 30px !important;
        }
        .upload_list:last-child {
            margin-right: 0;
        }

        /deep/.el-upload-dragger {
            padding: 20px 0;
            border: 1px solid #999;
        }

        /deep/.el-upload {
            width: 100%;
        }

        /deep/.el-upload-dragger .el-icon-upload {
            margin: 10px 0;
        }
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }


    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    .avatar {
        width: 50px !important;
        height: 50px !important;
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceAddByProduct.vue